import React, { Component, PropTypes } from 'react';
import { connect } from 'react-redux';
import SubHeader from '../subHeader/SubHeader';
import Header from '../Header/Header';

export class Layout extends Component {
  static propTypes = {
    children: PropTypes.element.isRequired,
    route: {}
  };

  render() {
    const { children } = this.props;
    const styles3 = {
      textAlign: 'center'
    };
    return <div>
      <div className="page-wrapper">
        <div className="top_header">
          <Header />
        </div>
        <SubHeader isLogin={this.props.route.isLogin} />
        {children}
        <div style={styles3}>
          <a>For more information, please contact us at: (852) 2523 3061</a>
        </div>
        <div style={styles3}>
          Copyright © 2017 AXA General Insurance Hong Kong Limited
        </div>
      </div>
    </div>;
  }
}

function mapStatesToProps(state) {
  return {
    lang: state.language.lang,
    url: state.routing.locationBeforeTransitions.pathname
  };
}

export default connect(mapStatesToProps)(Layout);



// WEBPACK FOOTER //
// ./src/app/components/layout/Layout.js